import { Box, Skeleton, styled } from '@mui/material'

export const SkeletonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: 'calc(100vh - 80px)',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    paddingTop: theme.spacing(5),
  },
}))

export const StyledSkeleton = styled(Skeleton)(({ theme }) => ({
  backgroundColor: theme.palette.surface['900'],
}))

export const StatSkeletonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
}))

export const StatSkeleton = styled(StyledSkeleton)(({ theme }) => ({
  width: '25%',
  height: theme.spacing(12),
  marginRight: theme.spacing(2),
  [theme.breakpoints.up('md')]: {
    width: '80%',
  },
}))

export const ModelSkeleton = styled(StyledSkeleton)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  width: 300,
  height: 300,
  [theme.breakpoints.up('md')]: {
    width: '60%',
    marginLeft: 'auto',
    marginRight: 0,
  },
}))

export const DescriptionSkeleton = styled(StyledSkeleton)(({ theme }) => ({
  width: '80%',
  height: 100,
  [theme.breakpoints.up('md')]: {
    width: '100%',
    marginRight: 0,
  },
}))

export const LogoSkeleton = styled(StyledSkeleton)(({ theme }) => ({
  margin: theme.spacing(4, 0),
  height: 60,
  width: '80%',
  [theme.breakpoints.up('md')]: {
    margin: theme.spacing(0, 0, 4, 0),
    width: 200,
  },
}))

export const ButtonSkeleton = styled(StyledSkeleton)(({ theme }) => ({
  height: 60,
  width: 120,
  marginBottom: theme.spacing(2),
  borderRadius: 10,
  [theme.breakpoints.up('md')]: {
    marginLeft: 0,
    marginRight: 0,
  },
}))
